import { get, post } from "./api";
import { getCurrentUserToken } from "./auth";
import type {
  ImportJobStatusResponse,
  ImportReviewItemsResponse,
  UploadImportResponse,
} from "../types/crmImport";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:5206";
const ACTIVE_ORG_STORAGE_KEY = "activeOrganizationId";

export const uploadImportFile = async (file: File): Promise<UploadImportResponse> => {
  const token = await getCurrentUserToken();
  const formData = new FormData();
  formData.append("file", file);

  const headers: Record<string, string> = {};
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const orgOverrideId = localStorage.getItem(ACTIVE_ORG_STORAGE_KEY);
  if (orgOverrideId) headers["X-Organization-Id"] = orgOverrideId;

  const response = await fetch(`${API_BASE_URL}/api/crm/import`, {
    method: "POST",
    headers,
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      (errorData as { message?: string }).message || `Upload failed: ${response.status}`
    );
  }

  return response.json();
};

export const getImportJobStatus = (jobId: string): Promise<ImportJobStatusResponse> =>
  get(`/api/crm/import/${jobId}`);

export const getReviewItems = (jobId: string): Promise<ImportReviewItemsResponse> =>
  get(`/api/crm/import/${jobId}/review`);

export const resolveReviewItem = (
  jobId: string,
  itemId: string,
  resolvedSchoolId: string
): Promise<{ message: string }> =>
  post(`/api/crm/import/${jobId}/review/${itemId}/resolve`, { resolvedSchoolId });

export const dismissReviewItem = (jobId: string, itemId: string): Promise<void> =>
  post(`/api/crm/import/${jobId}/review/${itemId}/dismiss`);
